<div class="title">
  <mat-icon>corporate_fare</mat-icon>
  TextSet Definitions
</div>
<div class="description">SELECT THE TEXTSET TO FILTER BY</div>

<div class="options" *ngIf="textSetDefinitions$ | async as textSetDefinitions; else loadingSpinner">
  <elements-filter-chip
    icon="sell"
    [caption]="textSetDefinition.name"
    [selected]="isSelected(textSetDefinition)"
    *ngFor="let textSetDefinition of textSetDefinitions"
    (click)="isSelected(textSetDefinition) ? remove(textSetDefinition) : add(textSetDefinition)"
  >
  </elements-filter-chip>
</div>

<div class="actions">
  <button styles-button (click)="close.emit()">Filter</button>
  <button styles-low-button (click)="clear()">Clear</button>
</div>

<ng-template #loadingSpinner>
  <elements-loading-spinner></elements-loading-spinner>
</ng-template>
